import { render, staticRenderFns } from "./Visits.vue?vue&type=template&id=331a83d7"
import script from "./Visits.vue?vue&type=script&lang=ts"
export * from "./Visits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports